
    export enum BotEventType {
    
    Alert = 1,
    Goal = 2
}
